import PropTypes from 'prop-types';
import React from 'react';
import BaseComponent from './BaseComponent';
import { safeJSONParse } from 'helpers/sf_utils';
import { Col, Row, Input } from 'reactstrap';

/**
 * InputComponent is a reusable React component that renders a form component field with an associated label and tooltip.
 * 
 * @param {Object} props - The props for the InputComponent.
 * @param {Object} props.label - An object containing properties related to the label.
 * @param {string} props.label.name - The name of the label.
 * @param {string} props.label.tooltip - The tooltip message for the label.
 * @param {Object} props.component - An object containing properties related to the component field.
 * @param {string} props.component.id - The ID of the component field.
 * @param {string} props.component.name - The name of the component field.
 * @param {string} props.component.type - The type of the component field (default is 'text').
 * @param {Object} props.validation - An object containing form validation properties.
 * @param {Function} props.validation.handleChange - The function to handle component changes.
 * @param {Function} props.validation.handleBlur - The function to handle component blur.
 * @param {Object} props.validation.values - An object containing form values.
 * @param {Object} props.validation.touched - An object indicating whether fields have been touched.
 * @param {Object} props.validation.errors - An object containing validation errors.
 * 
 * @returns {JSX.Element} - A React component that renders an component field with label and tooltip.
 */
const SelectComponent = ({ index, question, onChangeEvent }) => {
    const labelMap = {
        make: 'Select vehicle make',
        model: 'Select vehicle model',
        state: 'Select state'
      };  
      const label = labelMap[question?.original_field_name || question?.field_name] || 'Select'; 
    const question_drop_down_values = safeJSONParse(question?.drop_down_values, []);
    return (
        <BaseComponent question={question}>
            <Row key={index}>
                <Col md={12} className="">
                    <Input
                        type="select"
                        id={question?.id || ''}
                        name={question?.field_name || ''}
                        className="quote-funnel-form-control"
                        placeholder={question?.placeholder || ''}
                        value={question?.value || ''}
                        onChange={(e) => onChangeEvent(e.target.value)}>
                        <option value="" disabled hidden>{label}</option>
                        {question_drop_down_values.map(question_drop_down_value => (
                            <option value={question_drop_down_value.label} key={`q_${question?.field_name}_${question_drop_down_value.label}`}>
                                {question_drop_down_value.label}
                            </option>
                        ))}
                    </Input>

                </Col>
            </Row>
        </BaseComponent>
    );
}

SelectComponent.propTypes = {
    label: PropTypes.object,
    component: PropTypes.object,
    validation: PropTypes.object,
};

export default SelectComponent;
